const opsQueryKeys = {
    dev: () => ['dev'],
    previewUrls: () => [...opsQueryKeys.dev(), 'preview-urls'],
    previewUrlsInit: () => [...opsQueryKeys.previewUrls(), 'init'],
    axios: () => [...opsQueryKeys.dev(), 'axios'],
    axiosApiUrl: (url: string) => [...opsQueryKeys.axios(), 'url', url],
    axiosInterceptors: () => [...opsQueryKeys.axios(), 'interceptors'],
    remoteAssets: () => ['remote-assets'],
    editorCustomCss: () => [...opsQueryKeys.remoteAssets(), 'editor-custom-css'],
};

export { opsQueryKeys };
